import Header from '../utill/Header';
import Footer from '../utill/Footer';
import Sidebar from '../utill/Sidebar';
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Button, Card, Form, Table} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import Url from "../utill/Url";
import axios from "axios";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    styled,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {RootState} from "../../redux/store";

function ClientManagement() {
    const url = useContext(Url);
    const navigate = useNavigate();
    const [totalData, setTotalData] = useState();
    const [selected, setSelected] = useState("1");
    const [listCnt, setListCnt] = useState<number>(10);
    const [page, setPage] = useState<number>(1)
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState<AdvertisingType[]>([]);
    const user = useSelector((state: RootState) => state.user.value);
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);

    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-고객사 정보 관리'
        //@ts-ignore
        if (auth.MENUAUTH.AD0000.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        //@ts-ignore
        setWriteAuthorityYn(auth.MENUAUTH.AD0000.writeAuthorityYn === "1");
        reissue(userId, url, navigate).then(() => {
            let params = {
                adName: searchText,
                goodsName: searchText,
                listCnt: listCnt,
                page: page
            };
            axios.get(url + 'ad/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: params
            })
                .then((response) => {
                    setData(response.data.result.data)
                    setTotalData(response.data.result.totalData)
                })
        })
    }, []);

    const handleSubmit = async () => {
        reissue(userId, url, navigate).then(() => {
            let params: Params = {
                listCnt: listCnt,
                page: page,
            };

            if (selected === "1") {
                params.adName = searchText; // 광고명으로 검색
                params.goodsName = "";
            } else if (selected === "2") {
                params.adName = "";
                params.goodsName = searchText; // 상품명으로 검색
            }
            axios.get(url + 'ad/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: params,
            })
                .then((response) => {
                    setData(response.data.result.data)
                    setTotalData(response.data.result.totalData)
                })
        })
    }

    const handleAddClick = () => {
        navigate('/AdvertisingAdd')
    }

    const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value)
    }

    const handleChangeText = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value)
    }

    let selectedValueTitle = "";
    let selectedValueContent = "";

    if (selected === "1") {
        selectedValueTitle = "광고명으로";
        selectedValueContent = "광고명을";
    } else if (selected === "2") {
        selectedValueTitle = "상품명으로";
        selectedValueContent = "상품명을";
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
        }
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#DCDCDC',
            color: 'black',
            borderRightWidth: 1,
            borderRightColor: '#ffffff',
            '&:last-child': {
                borderRightColor: theme.palette.grey[300],
            },
            '&:first-child': {
                borderLeftColor: theme.palette.grey[300],
            },
            borderRightStyle: "solid",
        },
        [`&.${tableCellClasses.body}`]: {
            borderRightWidth: 1,
            borderRightColor: theme.palette.grey[300],
            borderRightStyle: "solid",
        },
    }));

    return (
        <div id="wrapper">
            <Sidebar menuCode={"AD0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='광고 관리'/>
                        <p className="header-message">해당 광고명, 상품명을 클릭하면 상세페이지로 이동합니다.</p>
                        <Card className="card shadow mb-4" style={{minHeight: "670px"}}>
                            <Card.Header className="py-3">
                                <div>
                                    <h6 className="m-0 font-weight-bold text-primary">{selectedValueTitle} 검색</h6>
                                    <p className="mb-2 mt-2 basic_font">{selectedValueContent} 기준으로 조회 합니다.</p>
                                </div>
                                <Form id="searchForm">
                                    <div className="form-group row">
                                        <Form.Select className="select_box" id='search_select' value={selected}
                                                     onChange={handleChangeSelect}>
                                            <option value="1">광고명</option>
                                            <option value="2">상품명</option>
                                        </Form.Select>
                                        <Form.Control type="text" onChange={handleChangeText}
                                                      value={searchText} onKeyDown={handleKeyDown}/>
                                        <div className="search_button_area">
                                            <Button variant="primary" className="search_button"
                                                    onClick={handleSubmit}>검색</Button>
                                            {writeAuthorityYn && <Button className="search_button" style={{marginLeft:'1rem'}} onClick={handleAddClick}>광고 등록</Button>}
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <div style={{display: 'flex'}}>
                                    <p className='card-body_content'>검색결과 : 총 {totalData}건</p>
                                </div>
                                <TableContainer component={Paper}>
                                    {/*@ts-ignore*/}
                                    <Table style={{marginBottom: 0}} sx={{ minWidth: 650}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell style={{width:"30rem"}} align="center">광고명</StyledTableCell>
                                                <StyledTableCell style={{width:"30rem"}} align="center">상품명</StyledTableCell>
                                                <StyledTableCell style={{width:"20rem"}} align="center">광고 기간</StyledTableCell>
                                                <StyledTableCell style={{width:"10rem"}} align="center">클릭 횟수</StyledTableCell>
                                                <StyledTableCell style={{width:"10rem"}} align="center">표출 횟수</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {writeAuthorityYn ? (<TableBody>
                                            {data.map((data) => (
                                                <TableRow component={Link} to='/AdvertisingView' className="custom-link"
                                                          state={{ id: data.id }}
                                                          key={data.adName}
                                                          sx={{
                                                              '&:hover td': {
                                                                  backgroundColor: 'rgba(0,111,255,0.13)'
                                                              },
                                                              '&:active td': {
                                                                  backgroundColor: 'rgba(0,149,255,0.13)'
                                                              }
                                                          }}
                                                >
                                                    <StyledTableCell align="center">{data.adName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.goodsName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.adDtm || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.clickCnt || "0"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.viewCnt || "0"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>) : (<TableBody>
                                            {data.map((data) => (
                                                <TableRow
                                                    key={data.id}
                                                    sx={{
                                                        '&:hover td': {
                                                            backgroundColor: 'rgba(0,111,255,0.13)'
                                                        },
                                                        '&:active td': {
                                                            backgroundColor: 'rgba(0,149,255,0.13)'
                                                        }
                                                    }}
                                                >
                                                    <StyledTableCell align="center">{data.adName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.goodsName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.adDtm || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.viewCnt || "0"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.clickCnt || "0"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>)}
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                        <div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}



export default ClientManagement;